var map = {
	"./BarterBook.png": "2f4d",
	"./FirstAidBook.png": "6e53",
	"./OutdoorsmanBook.png": "a157",
	"./RepairBook.png": "8234",
	"./ScienceBook.png": "cb36",
	"./SmallGunsBook.png": "ee32"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1dda";